export default "__VITE_PUBLIC_ASSET__febcfe3c__"